import React from 'react';
import { FaLinkedin, FaInstagram, FaFacebookF, FaTwitter, FaYoutube, FaSkype, FaSnapchatGhost, FaTiktok, FaWhatsapp, FaGlobe } from 'react-icons/fa';
import { TfiEmail } from 'react-icons/tfi';
import './Footer.css'
import { BsTelephoneOutbound } from "react-icons/bs";
import { Divider } from 'antd';
import { PiMediumLogoFill } from "react-icons/pi";
import { FaWhatsappSquare, FaInstagramSquare } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa6";
import { BsTwitterX } from "react-icons/bs";
import { RiMediumFill } from "react-icons/ri";
import { BsGlobe } from "react-icons/bs";
import { FaSnapchatSquare } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaFacebookSquare } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

const SocialIcons = ({ icons }) => (
  <div className="flex space-x-2">
    {icons.map((Icon, index) => (
      <Icon key={index} className="text-white text-xl hover:text-gray-300 cursor-pointer" />
    ))}
  </div>
);

const CustomFooter = () => {

    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();
  return (
    <>
      <svg width="0" height="0">
        <linearGradient id="instagram-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#fdf497', stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: '#fd5949', stopOpacity: 1 }} />
          <stop offset="75%" style={{ stopColor: '#d6249f', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#285AEB', stopOpacity: 1 }} />
        </linearGradient>
      </svg>
      <footer className="footer">
        <div className="container mx-auto max-w-[1400px] w-full pt-[50px] pb-[50px] max-h-[300px]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              {/* <h2 className="mb-4 text-[46px] text-white">DLP</h2> */}
              <img
                src={require('../../assets/mvp-logo.png')}
                alt="DLP Logo"
                className="mb-4"
                style={{ height: "auto", width:"80px"}} // Adjust size to match `text-[46px]`
              />
              {/* <p className="footer-description-text">
                {t("footer-description", "This platform is a national digital system for monitoring and reporting the use, maintenance, and environmental impact of cooling and heating equipment in Bosnia and Herzegovina.")}
              </p> */}
            </div>
            <div className='quick-links-div'>
              <h3 className="quick-links">{t("footer:quick-links", "Quick Links")}</h3>
              <ul className="options-div">
                <li><a href="/" className="options">{t("navbar:navigation-options:home", "Home")} <FaChevronRight className="right-arow" /></a></li>
              </ul>
            </div>
            <div className='contact-links-div'>
              <h3 className="contact-links">{t("footer:contact-us", "Contact us")}</h3>
              <div className="contact-div d-none">
                {['ministry-of-foreign-trade'].map((title) => (
                  <div className='contact-card' key={title}>
                    <p className="mb-2 title">{t(`footer:${title}`, title.replace(/-/g, ' '))}</p>
                    <div className="flex justify-between max-w-[70%] w-full">
                      <BsTelephoneOutbound color='#FFF' size={16} />
                      <a href="tel:+ 387 33 220 093" className='number-link'>+ 387 33 220 093</a><span className='number-link'>|</span><a href="tel:+ 387 33 214 102" className='number-link' > + 387 33 214 102</a>

                    </div>

                  </div>
                ))}
                {['federation-of-bosnia'].map((title) => (
                  <div className='contact-card' key={title}>
                    <p className="mb-2 title">{t(`footer:${title}`, title.replace(/-/g, ' '))}</p>
                    <div className="flex justify-between max-w-[194px] w-full">
                      <a href="https://www.facebook.com/p/Fond-za-za%C5%A1titu-okoli%C5%A1a-FBiH-100066393443346/" target='_blank'>
                        <FaFacebookSquare color='#1976D2' className="contact-icons" />
                      </a>
                    </div>
                    <div className="flex justify-between max-w-[154px] w-full mt-3">
                      <BsTelephoneOutbound color='#FFF' size={16} />
                      <a href="tel:+ 387 (0)33 723 680" className='number-link'>+ 387 (0)33 723 680</a>
                    </div>
                  </div>
                ))}
                {['republic-of-srpska'].map((title) => (
                  <div className='contact-card' key={title}>
                    <p className="mb-2 title">{t(`footer:${title}`, title.replace(/-/g, ' '))}</p>
                    <div className="flex justify-between max-w-[194px] w-full">
                      <a href="https://www.instagram.com/ekofondrs/" target='_blank'>
                        <FaInstagramSquare className="instagram-icon contact-icons" />
                      </a>
                      <a href="https://www.facebook.com/ekofondrs" target='_blank'>
                        <FaFacebookSquare color='#1976D2' className="contact-icons" />
                      </a>
                      <a href="https://www.linkedin.com/company/environmental-protection-and-energy-efficiency-fund-of-the-republic-of-srpska/" target='_blank'>
                        <FaLinkedin color='#117EB8' className="contact-icons" />
                      </a>
                      <a href="https://www.youtube.com/@ekofondrs" target='_blank'>
                        <FaYoutube color='#FD3832' className="contact-icons" />
                      </a>



                    </div>
                    <div className="flex justify-between max-w-[114px] w-full mt-3">
                      <BsTelephoneOutbound color='#FFF' size={16} />
                      <a href="tel:051/ 231-340" className='number-link'>051/ 231-340</a>
                    </div>
                  </div>
                ))}
                {['brcko-district'].map((title) => (
                  <div className='contact-card' key={title}>
                    <p className="mb-2 title">{t(`footer:${title}`, title.replace(/-/g, ' '))}</p>
                    <div className="flex justify-between max-w-[194px] w-full">
                      <a href="https://www.facebook.com/wwwbdcentral.net/" target='_blank'>
                        <FaFacebookSquare color='#1976D2' className="contact-icons" />
                      </a>
                   
                    </div>
                    <div className="flex justify-between max-w-[164px] w-full mt-3">
                      <BsTelephoneOutbound color='#FFF' size={16} />
                      <a href='tel:+ 387 (0) 49 / 240-817' className='number-link'>+ 387 (0) 49 / 240-817</a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* <Divider className="footer-divider" /> */}
          <div className='mail-div d-none'>
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4 mb-4 md:mb-0">
              <a href="mailto:info@mvteo.gov.ba" className="nav-icon flex items-center">
                <TfiEmail color="#055E9A" className="mail-icon" />info@mvteo.gov.ba
              </a>
              <a href="mailto:info@fzofbih.org.ba" className="nav-icon flex items-center">
                <TfiEmail color="#055E9A" className="mail-icon" />info@fzofbih.org.ba
              </a>
            </div>
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
              <a href="mailto:info@ekofondrs.org" className="nav-icon flex items-center">
                <TfiEmail color="#055E9A" className="mail-icon" />info@ekofondrs.org
              </a>
              {/* <a href="mailto:" className="nav-icon flex items-center">
              <TfiEmail color="#055E9A" className="mail-icon" />
            </a> */}
            </div>
          </div>
          <div>

          </div>
        </div>
        {/* <div className="copyright-text">
                  <p>{t("footer:copyright", "Copyright")} © {currentYear} OZON. {t("footer:allrights-by", "All Rights Reserved by")} <a className='footer-kgh' href='/'>OZON</a></p>
        </div> */}
      </footer>
    </>

  );

};

export default CustomFooter;